 // Toggle menu mobile
    const mobileToggle = document.getElementById('mobileToggle');
    const navbarMenu = document.getElementById('navbarMenu');

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function() {
        navbarMenu.classList.toggle('active');
      });
    }



// ============================================
    // CAROUSEL 3D PRODUITS
    // ============================================
    class Carousel3D {
      constructor() {
        this.container = document.getElementById('carouselContainer');
        this.cards = document.querySelectorAll('.product-card-modern');
        this.prevBtn = document.getElementById('prevBtn');
        this.nextBtn = document.getElementById('nextBtn');
        this.indicatorsContainer = document.getElementById('carouselIndicators');
        
        this.currentIndex = 0;
        this.totalCards = this.cards.length;
        this.angleIncrement = 360 / this.totalCards;
        this.radius = 280; // Rayon du cercle 3D
        this.autoRotateInterval = null;
        
        this.init();
      }
      
      init() {
        // Créer les indicateurs
        this.createIndicators();
        
        // Positionner les cartes initialement
        this.updateCarousel(false);
        
        // Event listeners
        this.prevBtn.addEventListener('click', () => {
          this.rotate(-1);
          this.resetAutoRotate();
        });
        this.nextBtn.addEventListener('click', () => {
          this.rotate(1);
          this.resetAutoRotate();
        });
        
        // Auto-rotation continue
        this.startAutoRotate();
        
        // Support tactile
        this.setupTouchControls();
      }
      
      createIndicators() {
        for (let i = 0; i < this.totalCards; i++) {
          const dot = document.createElement('div');
          dot.classList.add('indicator-dot');
          if (i === 0) dot.classList.add('active');
          dot.addEventListener('click', () => this.goToSlide(i));
          this.indicatorsContainer.appendChild(dot);
        }
      }
      
      updateCarousel(animate = true) {
        this.cards.forEach((card, index) => {
          const angle = (index - this.currentIndex) * this.angleIncrement;
          const radian = (angle * Math.PI) / 180;
          
          // Position en cercle
          const x = Math.sin(radian) * this.radius;
          const z = Math.cos(radian) * this.radius - this.radius;
          
          // Scale et opacité basés sur la position
          const normalizedZ = (z + this.radius) / (this.radius * 2);
          const scale = 0.85 + (normalizedZ * 0.15);
          const opacity = index === this.currentIndex ? 1 : 0.6 + (normalizedZ * 0.4);
          
          // Z-index pour la superposition correcte
          const zIndex = Math.round(normalizedZ * 100);
          
          if (animate) {
            card.style.transition = 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
          } else {
            card.style.transition = 'none';
          }
          
          card.style.transform = `
            translate(-50%, -50%)
            translateX(${x}px)
            translateZ(${z}px)
            scale(${scale})
            rotateY(${-angle}deg)
          `;
          card.style.opacity = opacity;
          card.style.zIndex = zIndex;
          
          // Désactiver les interactions pour les cartes non centrales
          if (index === this.currentIndex) {
            card.style.pointerEvents = 'auto';
          } else {
            card.style.pointerEvents = 'none';
          }
        });
        
        // Mettre à jour les indicateurs
        this.updateIndicators();
      }
      
      updateIndicators() {
        const dots = this.indicatorsContainer.querySelectorAll('.indicator-dot');
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === this.currentIndex);
        });
      }
      
      rotate(direction) {
        this.currentIndex = (this.currentIndex + direction + this.totalCards) % this.totalCards;
        this.updateCarousel();
      }
      
      goToSlide(index) {
        this.currentIndex = index;
        this.updateCarousel();
        this.resetAutoRotate();
      }
      
      startAutoRotate() {
        this.autoRotateInterval = setInterval(() => {
          this.rotate(1);
        }, 3000); // Rotation toutes les 3 secondes
      }
      
      stopAutoRotate() {
        if (this.autoRotateInterval) {
          clearInterval(this.autoRotateInterval);
        }
      }
      
      resetAutoRotate() {
        this.stopAutoRotate();
        this.startAutoRotate();
      }
      
      setupTouchControls() {
        let startX = 0;
        let isDragging = false;
        
        this.container.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          isDragging = true;
        });
        
        this.container.addEventListener('touchmove', (e) => {
          if (!isDragging) return;
          e.preventDefault();
        });
        
        this.container.addEventListener('touchend', (e) => {
          if (!isDragging) return;
          
          const endX = e.changedTouches[0].clientX;
          const diff = startX - endX;
          
          if (Math.abs(diff) > 50) {
            this.rotate(diff > 0 ? 1 : -1);
            this.resetAutoRotate();
          }
          
          isDragging = false;
        });
      }
    }
    
    // ============================================
    // ANIMATIONS AU SCROLL
    // ============================================
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observer tous les éléments à animer
    document.addEventListener('DOMContentLoaded', () => {
      // Initialiser le carousel 3D
      new Carousel3D();
      
      const animatedElements = document.querySelectorAll(
        '.category-home-card, .step-card, .review-card'
      );
      
      animatedElements.forEach((el, index) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = `all 0.6s ease ${index * 0.1}s`;
        observer.observe(el);
      });

      // Animation des téléphones 3D
      animatePhones();
      
      // Compteur animé
      animateCounters();
    });

    // Animation d'entrée des téléphones
    function animatePhones() {
      const phones = document.querySelectorAll('.phone-card');
      
      phones.forEach((phone, index) => {
        phone.style.opacity = '0';
        phone.style.transform = 'translateY(100px) scale(0.8)';
        
        setTimeout(() => {
          phone.style.transition = 'all 1s cubic-bezier(0.34, 1.56, 0.64, 1)';
          phone.style.opacity = phone.classList.contains('phone-1') ? '1' : 
                                phone.classList.contains('phone-2') ? '0.8' : '0.6';
          
          if (phone.classList.contains('phone-1')) {
            phone.style.transform = 'translate(-50%, -50%) rotateY(-15deg) scale(1)';
          } else if (phone.classList.contains('phone-2')) {
            phone.style.transform = 'translate(-50%, -50%) rotateY(20deg) scale(0.85)';
          } else if (phone.classList.contains('phone-3')) {
            phone.style.transform = 'translate(-50%, -50%) rotateY(-25deg) scale(0.75)';
          }
        }, index * 200);
      });
    }

    // Animation des compteurs
    function animateCounters() {
      const stats = document.querySelectorAll('.stat-item strong');
      
      const animateValue = (element, target, suffix = '') => {
        const duration = 2000;
        const start = 0;
        const increment = target / (duration / 16);
        let current = start;
        
        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            element.textContent = target + suffix;
            clearInterval(timer);
          } else {
            element.textContent = Math.floor(current) + suffix;
          }
        }, 16);
      };
      
      const statsObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const text = entry.target.textContent;
            const value = parseInt(text.replace(/\D/g, ''));
            const suffix = text.includes('+') ? '+' : 
                          text.includes('/') ? '/5' : 
                          text.includes('%') ? '%' : '';
            
            animateValue(entry.target, value, suffix);
            statsObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      
      stats.forEach(stat => statsObserver.observe(stat));
    }

    // Smooth scroll
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        
        if (target) {
          const offsetTop = target.offsetTop - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });

    // Animation bouton panier
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('btn-add-cart')) {
        e.preventDefault();
        const button = e.target;
        
        button.style.transform = 'scale(0.95)';
        setTimeout(() => {
          button.style.transform = 'scale(1)';
        }, 100);
        
        const cartIcon = document.querySelector('.nav-icon[aria-label="Panier"]');
        
        if (cartIcon) {
          const rect = button.getBoundingClientRect();
          const cartRect = cartIcon.getBoundingClientRect();
          
          const flyingItem = document.createElement('div');
          flyingItem.textContent = '🛒';
          flyingItem.style.position = 'fixed';
          flyingItem.style.left = rect.left + 'px';
          flyingItem.style.top = rect.top + 'px';
          flyingItem.style.fontSize = '24px';
          flyingItem.style.zIndex = '10000';
          flyingItem.style.transition = 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)';
          flyingItem.style.pointerEvents = 'none';
          
          document.body.appendChild(flyingItem);
          
          setTimeout(() => {
            flyingItem.style.left = cartRect.left + 'px';
            flyingItem.style.top = cartRect.top + 'px';
            flyingItem.style.transform = 'scale(0)';
            flyingItem.style.opacity = '0';
          }, 10);
          
          setTimeout(() => {
            document.body.removeChild(flyingItem);
            cartIcon.style.transform = 'scale(1.2)';
            setTimeout(() => {
              cartIcon.style.transform = 'scale(1)';
            }, 200);
          }, 800);
        }
        
        button.textContent = '✓ Ajouté';
        button.style.background = 'linear-gradient(135deg, #d4f4dd 0%, #e8fff0 100%)';
        button.style.color = '#0f5132';
        
        setTimeout(() => {
          button.textContent = 'Ajouter au panier';
          button.style.background = '';
          button.style.color = '';
        }, 2000);
      }
    });